import React from 'react';
import './HeroSection.css';

interface HeroSectionProps {
  eyebrow?: string;
  title: string;
  highlight?: string;
  subtitle: string;
  processLabel?: string;
  processSteps?: number;
  stats?: {
    value: string;
    label: string;
  }[];
  actions?: {
    primary?: {
      text: string;
      onClick: () => void;
    };
    secondary?: {
      text: string;
      onClick: () => void;
    };
  };
  showChart?: boolean;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  eyebrow,
  title,
  highlight,
  subtitle,
  processLabel,
  processSteps,
  stats,
  actions,
  showChart = false
}) => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          {eyebrow && <div className="eyebrow">{eyebrow}</div>}
          <h1 className="hero-title">
            {title}
            {highlight && <span className="hero-highlight">{highlight}</span>}
          </h1>
          <p className="hero-subtitle">{subtitle}</p>

          {(processSteps || (stats && stats.length > 0)) && (
            <div className="hero-process-strip">
              {processSteps && processSteps > 0 && (
                <div className="hero-steps-mini">
                  <div className="hero-steps-figure">{processSteps}</div>
                  <div className="hero-steps-body">
                    {processLabel && <div className="hero-steps-label">{processLabel}</div>}
                    <div className="hero-steps-ticks">
                      {Array.from({ length: processSteps }, (_, i) => (
                        <span key={i} className="hero-tick"></span>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {stats && stats.length > 0 && (
                <div className="hero-stats">
                  {stats.map((stat, index) => (
                    <div key={index} className="stat-item">
                      <div className="stat-value">{stat.value}</div>
                      <div className="stat-label">{stat.label}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {actions && (
            <div className="hero-actions">
              {actions.primary && (
                <button className="btn-primary" onClick={actions.primary.onClick}>
                  {actions.primary.text}
                </button>
              )}
              {actions.secondary && (
                <button className="btn-secondary" onClick={actions.secondary.onClick}>
                  {actions.secondary.text}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
